import { endOfDay, startOfDay, subDays } from '@if/core/date'
import * as yup from '@if/core/yup'

export const AgentLogEntryFilterSchema = yup.object({
  startDate: yup
    .date()
    .required()
    .default(startOfDay(subDays(new Date(), 7))),
  endDate: yup.date().required().default(endOfDay(new Date())),
})

export type AgentLogEntryFilterSchemaType = yup.InferSubmit<typeof AgentLogEntryFilterSchema>
